<template>
  <v-card elevation="0" class="text-xs-center">
    <ul class="list-group reset img-drag drag" v-if="loaded">
      <draggable :list="form.images" @change="log(form.images)" class="dragArea handle">
        <li v-for="item in form.images" :key="item.id">
          <div class="img-drag-item handle">
            <a hre="#" class="del-product-image" v-on:click="deleteImage(item)">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </a>
            <img :src="item.product_image" style="width:100% " />
            <a
              class="set-default"
              v-on:click.prevent="setDefaltImage(item)"
              :class="item.default ? 'active-star': ''"
            >
              <i class="fas fa-star"></i>
            </a>
          </div>
        </li>
      </draggable>
    </ul>
    <loading-block v-else></loading-block>
    <br />
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="openAttachmentPopup()"
          v-on="on"
          fab
          dark
          color="primary"
          depressed
          bottom
          right
          fixed
          :style="$root.rightNav?'margin-right:260px; margin-bottom:30px;':'margin-bottom:30px;'"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Add Image</span>
    </v-tooltip>
  </v-card>
</template>
<script>
import { ProductAPI } from '@/clients/product/product.api'
import Helper from '@/utility/Helpers'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
export default {
  components: {
    draggable,
    LoadingBlock
  },
  data() {
    return {
      normalValidation: [
        v => !!v || 'Field is required'
      ],
      type: 'add',
      loaded: false,
      form: {
        images: []
      }
    }
  },
  computed: {
    ...mapGetters({
      activeItem: 'product/activeItem'
    })
  },
  watch: {

  },
  mounted() {
    this.spinner(false)
    if (!_.isEmpty(this.activeItem)) {
      this.fetchAndSetProductImages()
    }

    /**
    * Set image
    */
    this.$root.$on('resource-selected', (event) => {
      this.setMaterProductImage(event)
    })
  },
  beforeDestroy() {
    this.$root.$off('resource-selected');
  },
  methods: {
    /**
     * fetch and set product images
     */

    async fetchAndSetProductImages() {
      let res = await ProductAPI.fetchImages(this.activeItem.id)
      if (res.status === 200) {
        this.type = 'delete'
        this.form.images = res.data.payload
      }
      this.loaded = true
    },

    log: function (arr) {
      this.arrangeImages(arr)
    },

    /**
    * Select image
    *
    * */
    async setMaterProductImage(resources) {
      if (!resources[0].full_url) {
        console.log('Unable to find image path')
        return false
      }
      this.spinner(true)
      let res = await ProductAPI.addImage(this.activeItem.id, {
        product_image: resources[0].full_url,
        order: this.form.images.length + 1,
        default: this.form.images.length > 1 ? 0 : 1
      })
      this.spinner(false)
      if (res.status === 200) {
        this.snackbar({
          text: 'Successfully added.',
          open: true,
          color: 'success'
        })
        // Now fetch all images
        this.fetchAndSetProductImages()
      } else {
        this.snackbar({
          text: 'Unable to add image. Please try again later.',
          open: true,
          color: 'error'
        })
      }
    },

    /**
     * Arrange image order
     */
    arrangeImages: _.debounce(async function (arr) {
      try {
        let orderedId = Helper.getFieldValueInArray(arr, 'id')
        await ProductAPI.updateSort({
          'product_image_id': orderedId
        })
      } catch (err) {
        console.log('unable to sort.')
      }
    }, 2000),

    /**
     * Set default image
     */
    async setDefaltImage(item) {
      this.spinner(true)
      let res = await ProductAPI.updateImageDefault(this.activeItem.id, item.id, {
        'product_image': item.product_image,
        'default': 1
      })
      this.spinner(false)
      if (res.status === 200) {
        this.fetchAndSetProductImages()
        // After chnage in feature ed image , image must be chnaged in active item + list items
        // Update list item
        await ProductAPI.list()
        // Update active item
        await ProductAPI.fetchProductDetail(this.activeItem.id)
      } else {
        this.snackbar({
          text: 'Cannot feature image. Please try again later.',
          open: true,
          color: 'error'
        })
      }
    },

    /**
     * Delete
     */
    deleteImage(obj) {
      const self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        html: `You are about to delete image.`,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        buttonsStyling: false,
        customClass: {
          container: 'custom-swal'
        }
      }).then(async function (result) {
        if (result.value) {
          self.spinner(true)
          let res = await ProductAPI.deleteProductImage(self.activeItem.id, obj.id)
          self.spinner(false)
          if (res.status === 200) {
            self.fetchAndSetProductImages()
            self.$swal(
              'Deleted!',
              `Successfully deleted.`,
              'success'
            )
          } else {
            self.$swal(
              'Failed!',
              'Please try again later.',
              'error'
            )
          }
        }
      })
    },

    /**
     * Close modal
     */
    closeModal() {
      this.setProductImagesPopup(false)
      this.setProductImagesObj({})
      this.type = 'add'
      this.form.images = []
    },

    /**
    * Popup for attachment
    */
    openAttachmentPopup() {
      this.openResourcePicker()
    },

    ...mapActions({
      setActiveItem: 'product/setActiveItem',
      setProductImagesPopup: 'product/setProductImagesPopup',
      setProductImagesObj: 'product/setProductImagesObj'
    })
  }
}
</script>
<style>
.set-default {
  cursor: pointer;
  width: auto;
  position: absolute;
  left: 9px;
  top: 12px;
  cursor: pointer;
  width: 25px;
  color: #4b4b4b;
}
.set-default:hover {
  color: #db563f !important;
}
.set-default.active-star {
  color: #db563f !important;
}
a.set-default {
  color: #bbbbbb !important;
}
a.set-default.active-star {
  color: #db563f !important;
}
a.del-product-image {
  color: #333 !important;
}
.image-list {
  position: relative;
  cursor: grab;
}
.dragArea {
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  margin-right: -10px;
  margin-left: -10px;
}
.img-drag li {
  position: relative;
  padding: 10px;
  flex: 0 0 25%;
  max-width: 25%;
}
.img-drag {
  list-style-type: none;
  padding-left: 0;
}
.img-drag-item {
  padding: 15px;
  border: 1px solid #dadada;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 5px #ccc;
  align-items: center;
  justify-content: center;
  cursor: grab;
}
</style>
